import LazyComponent from "v-lazy-component";

const Plugin = {
  install(app) {
    app.use(LazyComponent);
  },
};

export default Plugin;
